import { useTranslation } from "react-i18next";
import { cn } from "ui";
import { formatBillingAmount } from "utils";

import {
  getAthleteLimitLabel,
  getPriceUnitLabel,
} from "src/helpers/billingLabels";
import { type BillingPrice, type BillingProduct } from "src/queries/billing";

interface Props {
  product: BillingProduct;
  price: BillingPrice;
  selected: boolean;
  isCurrent: boolean;
  onSelect: (price: BillingPrice, product: BillingProduct) => void;
}

export function BillingProductPickerCard(props: Props) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => {
        props.onSelect(props.price, props.product);
      }}
      className={cn("rounded-xl border p-4 text-left transition-colors", {
        "border-emerald-600 bg-emerald-50/60": props.selected,
        "border-gray-200 bg-white hover:border-gray-300": !props.selected,
      })}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="font-semibold text-gray-900">
          {props.product.name}
        </span>
        {props.isCurrent && (
          <span className="rounded-full bg-szt-black px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
            {t("billing.changePlan.current")}
          </span>
        )}
      </div>
      <p className="mt-3 text-xl font-bold tracking-tight text-gray-900">
        {formatBillingAmount(props.price.unitAmount, props.price.currency)}
      </p>
      <p className="text-xs text-gray-500">
        {getPriceUnitLabel(t, props.price.interval)}
      </p>
      <p className="text-xs text-gray-500">{t("pricing.includesVat")}</p>
      <p className="mt-3 text-sm text-gray-700">
        {getAthleteLimitLabel(t, props.product.athleteLimit)}
      </p>
    </button>
  );
}
